"use strict";

exports.__esModule = true;
exports.default = void 0;
var _utils = require("../utils");
var _zzUtils = require("@zz-common/zz-utils");
var Native;
if (!_utils.isServer) {
  Native = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}
var _default = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "video",
      style: _vm.style
    }, [_c('video', {
      ref: "video",
      staticClass: "video-item",
      attrs: {
        "controls": _vm.controls,
        "muted": "",
        "autoplay": _vm.auto || _vm.isWifi,
        "src": _vm.videoUrl,
        "poster": _vm.setPicSize(_vm.picUrl),
        "webkit-playsinline": "",
        "playsinline": "",
        "x5-playsinline": "",
        "x5-video-player-type": "h5-page",
        "x5-video-player-fullscreen": "true"
      },
      domProps: {
        "muted": true
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.onVideoClick($event);
        },
        "ended": _vm.onEnded,
        "play": _vm.onPlay,
        "pause": function pause($event) {
          return _vm.$emit('pause');
        },
        "timeupdate": function timeupdate($event) {
          return _vm.$emit('timeupdate');
        },
        "volumechange": function volumechange($event) {
          return _vm.$emit('volumechange');
        },
        "fullscreenchange": function fullscreenchange($event) {
          return _vm.$emit('fullscreenchange');
        }
      }
    }), _vm.muteBtn ? _c('span', {
      class: ['video-muted-img', _vm.videoMutedState ? '' : 'video-sound-img'],
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.changevideoMutedState($event);
        }
      }
    }) : _vm._e(), _vm.fullScreen ? _c('span', {
      staticClass: "full-screen-img",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.onFullScreen($event);
        }
      }
    }) : _vm._e(), _vm.showPlay ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.show,
        expression: "show"
      }],
      staticClass: "play",
      on: {
        "click": _vm.onVideoClick
      }
    }, [!_vm.playPause ? _c('img', {
      attrs: {
        "src": _vm.btnUrl
      }
    }) : _vm._e()])] : _vm._e()], 2);
  },
  name: 'z-biz-video',
  components: {},
  props: {
    showPlay: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Boolean,
      default: false
    },
    videoUrl: {
      type: String,
      default: ''
    },
    picUrl: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    px2rem: {
      type: Boolean,
      default: false
    },
    auto: {
      type: Boolean,
      default: true
    },
    wifiAuto: {
      type: Boolean,
      default: false
    },
    muteBtn: {
      type: Boolean,
      default: true
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    btnUrl: {
      type: String,
      default: 'https://pic5.zhuanstatic.com/zhuanzh/ba50a305-3d92-469d-8ea9-3d5c85b0693d.png'
    },
    playPauseWithTimer: {
      type: Boolean,
      default: true
    },
    playFullScreen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      setPicSize: _zzUtils.setPicSize,
      playPause: false,
      // 播放暂停按钮
      show: true,
      // 显示播放暂停按钮
      timer: null,
      isWifi: false,
      videoMutedState: true // 是否静音
    };
  },

  computed: {
    style: function style() {
      var style = {};
      style.width = this.px2rem ? (0, _utils.suffixRem)(this.width) : (0, _utils.suffixPx)(this.width);
      style.height = this.px2rem ? (0, _utils.suffixRem)(this.height) : (0, _utils.suffixPx)(this.height);
      return style;
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.wifiAuto) {
      if (!_utils.isServer && this.$expandAdapter) Native = this.$expandAdapter;
      Native.wrap('getWifiInfo')({}, function (res) {
        console.log('getWifiInfo', res);
        if (res.code === 0 && res.connected === 1) {
          _this.isWifi = true;
          _this.videoMutedState = true;
        }
      });
    }
  },
  methods: {
    // 监听播放结束
    onEnded: function onEnded() {
      this.show = true;
      clearTimeout(this.timer);
      this.timer = null;
      this.playPause = false;
      this.$emit('ended', this.$refs.video);
    },
    // 监听开始播放
    onPlay: function onPlay() {
      if (this.isWifi) {
        this.playPause = true;
      }
      this.$emit('started', this.$refs.video);
    },
    // 点击视频区域或者按钮
    onVideoClick: function onVideoClick() {
      var v = this.$refs.video;
      if (this.playPause) {
        this.show = !this.show;
        v.pause();
      } else {
        this.show = false;
        v.play();
        if (this.playFullScreen) this.onFullScreen();
      }
      this.playPauseWithTimer ? this.setTimer() : clearTimeout(this.timer);
      this.playPause = !this.playPause;
      this.$emit('click');
    },
    // 控制是否静音
    changevideoMutedState: function changevideoMutedState() {
      var ref = this.$refs;
      ref.video.muted = !ref.video.muted;
      this.videoMutedState = !this.videoMutedState;
    },
    // 设置定时器
    setTimer: function setTimer() {
      var _this2 = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this2.show = false;
      }, 2300);
    },
    onFullScreen: function onFullScreen() {
      var v = this.$refs.video;
      this.FullScreen(v);
    },
    // 兼容各种机型的全屏模式
    FullScreen: function FullScreen(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullScreen) {
        ele.webkitRequestFullScreen();
      } else if (ele.webkitEnterFullScreen) {
        ele.webkitEnterFullScreen();
      }
    }
  }
};
exports.default = _default;